module.exports = __webpack_public_path__ + "media/images/favicon-32x32-699550246c2bc310c513e8bc26c3387c.png";